<template>
  <!-- 登录 -->
  <div
    class="box"
    style="min-width: 1600px;"
  >
    <NavBar
      navIndex="6"
      :imgHeight="482"
    ></NavBar>
    <!-- <div style="padding:30px;"></div> -->
    <div style="position:relative;width: 100%;">
      <img
        style="display: block;width: 100%;"
        src="../assets/job-fair-bg.png"
        alt=""
        class="mod-section-ad"
      >

      <div class="animate__animated animate__mian slogan">
        <div class="slogan-title">携手同行</div>
        <div class="slogan-subtitle">
          享受工作与生活，一起创造美好未来
        </div>
      </div>
    </div>

    <div class="mw-1200 m_auto content-box">
      <div class="pt50_pb100 ">
        <contentTitle
          text='人才理念'
          :centered="false"
        />
        <div class="mt_50 ff-pb">
          弘知教育始终以对优秀人才的吸引和培养为核心战略之一，高度重视员工的福利待遇和成长进步。除了提供行业内极具竞争力的薪酬之外，还致力于为每一位员工的发展、家庭、生活和健康提供贴心的关怀和服务。
        </div>
      </div>

      <div
        class="pt50_pb100"
        ref="hotJob"
      >
        <contentTitle
          text='热招岗位'
          :centered="false"
        />
        <div class="mt_50 ff-pb">
          与志同道合的人一起做有意义的事情。

          <a
            href="https://www.zhipin.com/gongsi/df5ccbd8ca2775001nx-2Nu-GFI~.html?ka=company-intro"
            target="_Blank"
          >
            <div class="btn recruit-btn">
              查看岗位
            </div>
          </a>

        </div>
      </div>

      <div class="pt50_pb100">
        <contentTitle
          text='招聘流程'
          :centered="false"
        />
        <div class="mt_50">
          <img
            src="../assets/images/recruitment.png"
            alt=""
            style="width: 100%;"
          >
        </div>
      </div>

      <div class="pt50_pb100">
        <contentTitle
          text='薪酬福利'
          :centered="false"
        />
        <div class="mt_50 benefits-big-box">
          <div
            class="benefits-box df fd_c ai_c"
            v-for="(item,index) in benefitsList"
            :key="index"
          >
            <img
              :src="item.img"
              alt=""
            >
            <p class="ff-pb">{{item.title}}</p>
            <div>{{item.content}}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div
      v-if="page_control === '1'"
      style="background-color: #F7F7F7;padding: 0 0 50px;"
    >
      <div style="width: 1200px;margin:0 auto;display: flex;flex-wrap: wrap;padding-top: 50px;min-height: 600px;">
        <div
          v-for="(item,index) in jobData"
          :key="index"
          class="job-cell"
          @click="lookJob(item)"
        >
          <div>{{item.time}}</div>
          <div style="margin-top: 10px;color: #333333;font-size: 20px;font-weight: 800;">{{item.inviteOne}}</div>
          <div style="margin: 20px 0;width: 100%;height:1px;background-color: #F7F7F7;"></div>
          <div style="color: #666666;">工作地点：{{item.inviteAddress}}</div>
          <div style="color: #666666;margin-top: 10px;">招聘人数：{{item.inviteTwo}}位</div>
          <div style="color: #666666;margin-top: 10px;">薪资待遇：{{item.invitePay}}</div>
          <div style="background-color:#0050A7;width:50px;height:30px;color:#fff;text-align: center;line-height: 30px;font-size: 14px;margin-top: 10px;float: right;">详情</div>
          <div style="clear: both;"></div>
        </div>
      </div>
      <div class="pagination-block">
        <el-pagination
          @current-change="changepagination"
          layout="prev, pager, next"
          :page-size="6"
          :total="total"
        >
        </el-pagination>
      </div>

    </div>

    <div
      v-else
      style="background-color: #F7F7F7;padding: 0 0 50px;"
    >
      <div style="width: 1200px;margin: auto;">
        <div style="display: flex;align-items: center;padding: 30px 0 20px;">
          <div
            class="select-status"
            style="cursor:pointer;"
            @click="goHome()"
          > 首页 </div>
          <div style="margin: 0 10px;"> > </div>
          <div
            class="select-status"
            style="cursor:pointer;"
            @click="showJob()"
          >人才招聘</div>
          <div style="margin: 0 10px;"> > </div>
          <div style="cursor:pointer;">{{jobContent.inviteOne}}</div>

        </div>

        <div style="background-color: #fff;padding: 30px 40px;box-sizing: border-box;">
          <div class="teacher-classify">
            {{jobContent.inviteOne}}
            <div class="teacher-classify-border"></div>
          </div>

          <div style="color: #999999;font-size: 12px;">发布时间：{{jobContent.time}}</div>
          <div style="margin: 20px 0;width: 100%;height:1px;background-color: #F7F7F7;"></div>
          <div style="color:#333333;font-weight:600;">工作地点：{{jobContent.inviteAddress}}</div>
          <div style="color:#333333;font-weight:600;margin-top: 10px;">工作性质：{{jobContent.inviteNature}}</div>
          <div style="color:#333333;font-weight:600;margin-top: 10px;">学历要求：{{jobContent.inviteStudy}}</div>
          <div style="color:#333333;font-weight:600;margin-top: 10px;">工作年限：{{jobContent.inviteCount}}</div>
          <div style="color:#333333;font-weight:600;margin-top: 10px;">薪资待遇：{{jobContent.invitePay}}</div>
          <div style="color:#333333;font-weight:600;margin-top: 10px;">招聘人数：{{jobContent.inviteTwo}}位</div>
          <div style="font-size:20px;color:#333333;font-weight:600;margin: 30px 0 10px;">职位描述</div>
          <div
            id="formStr"
            v-html="jobContent.inviteDesc"
          >{{ jobContent.inviteDesc }}</div>

          <div style="display: flex;justify-content: space-between;margin-top: 20px;">
            <div style="display: flex;justify-content: center;align-items: center;margin: 30px 0 10px;">
              <img
                style="width: 16px;height:16px;margin-right: 10px;"
                src="../assets/phone-icon.png"
                alt=""
              >
              <div style="color: #333333;font-weight: 600;">有意向请电联：18867429116</div>
            </div>

            <div style="display: flex;justify-content: center;align-items: center;margin: 30px 0 10px;">
              <img
                style="width: 16px;height:16px;margin-right: 10px;"
                src="../assets/mail-icon.png"
                alt=""
              >
              <div style="color: #333333;font-weight: 600;">邮箱号码：hzjy@hncshzjyjt.com</div>
            </div>

            <div style="display: flex;justify-content: center;align-items: center;margin: 30px 0 10px;">
              <img
                style="width: 16px;height:16px;margin-right: 10px;"
                src="../assets/wx-icon.png"
                alt=""
              >
              <div style="color: #333333;font-weight: 600;">微信号：hzjy@hncshzjyjt.com</div>
            </div>
          </div>

        </div>
      </div>
    </div> -->

    <Footer></Footer>
  </div>
</template>

<script>
import NavBar from "@/components/navBar.vue";
import Footer from "@/components/Footer.vue";
import contentTitle from "@/components/contentTitle.vue";
import { jobFair } from "@/request/api";

export default {
  name: "jobFair",
  components: {
    NavBar,
    Footer,
    contentTitle,
  },
  data() {
    return {
      page_control: "1",
      jobData: [],
      total: 6,
      jobContent: {}, //工作信息详情
      benefitsList: [
        {
          img: require("../assets/images/money.png"),
          title: "涨薪制度",
          content: "每年4次涨薪机会,课时费每月1次晋升机会",
        },
        {
          img: require("../assets/images/excellent.png"),
          title: "激励政策",
          content: "股份激励、课耗激励、业绩达成奖、优秀老师奖、年终奖金等",
        },
        {
          img: require("../assets/images/holidays.png"),
          title: "考勤福利",
          content: "双休、享受法定节假日",
        },
        {
          img: require("../assets/images/medical.png"),
          title: "保险福利",
          content:
            "五险一金（养老保险、医疗保险、失业保险、工伤保险、生育保险、住房公积金）",
        },
        {
          img: require("../assets/images/wallet.png"),
          title: "礼金福利",
          content: "结婚礼金、生育慰问金、生日礼金、亲友报班优惠、子女报班优惠",
        },
        {
          img: require("../assets/images/collection.png"),
          title: "日常福利",
          content: "自助食堂、温馨宿舍、丰富的员工活动、定期带薪团建等",
        },
        {
          img: require("../assets/images/trend.png"),
          title: "企业补充福利",
          content: "5-20天带薪年假，生育假、节日物资、交通补贴、通讯补贴等",
        },
        {
          img: require("../assets/images/sprouting.png"),
          title: "特殊福利",
          content: "高额购房补贴、购车补贴等",
        },
      ],
      talentShow: false,
      hotJobShow: false,
    };
  },
  mounted() {
    let that = this;
    jobFair("pageNum=1&pageSize=6").then((res) => {
      // console.log("招聘", res.data);
      let data = res.data.result;
      data.forEach(function (res, index) {
        res.time = res.insertDate.slice(0, 10);
      });
      that.jobData = data;
      that.total = res.data.total;
    });
  },
  methods: {
    lookJob(e) {
      let that = this;
      // that.page_control = "2"
      // this.jobContent = e
      sessionStorage.setItem("job_detail", JSON.stringify(e));
      this.$router.push({ name: "jobDetail" });
    },
    showJob() {
      this.page_control = "1";
    },
    goHome() {
      this.$router.push("/");
    },
    changepagination(e) {
      console.log(e);
      let that = this;
      jobFair("pageSize=6&pageNum=" + e).then((res) => {
        console.log("招聘", res.data.result);
        let data = res.data.result;
        data.forEach(function (res, index) {
          res.time = res.insertDate.slice(0, 10);
        });
        that.jobData = data;
      });
    },
  },
};
</script>

<style scoped>
.content-title-border {
  position: absolute;
  width: 32px;
  height: 4px;
  background-color: #fff;
  left: 50%;
  transform: translateX(-50%);
  bottom: -15%;
}
.job-cell {
  width: 31%;
  background-color: #fff;
  padding: 30px;
  box-sizing: border-box;
  margin: 10px;
  cursor: pointer;
}
.job-cell:hover {
  box-shadow: 0 0 8px 5px #eaeaea;
}

.teacher-classify {
  position: relative;
  font-size: 26px;
  font-weight: bold;
  width: 70%;
  margin-bottom: 25px;
}
.teacher-classify-border {
  position: absolute;
  width: 32px;
  height: 2px;
  background-color: #0050a7;
  bottom: -25%;
}

.select-status:hover {
  color: #004ea3;
  /* font-weight: 600; */
}

/* 分页 */
.pagination-block {
  text-align: center;
  margin: 30px;
}

.recruit-btn {
  margin-top: 38px;
}

.benefits-big-box {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 32px;
}

.benefits-box {
  margin-bottom: 58px;
}

.benefits-box img {
  width: 30px;
  margin-right: 12px;
}

.content-box {
  /* font-weight: 700; */
}
</style>
        